// extracted by mini-css-extract-plugin
export default {"container":"container-VxUoFB","breadcrumbItem":"breadcrumbItem-j4C3b_"};